// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2tSBo","filesListContainer":"PosDisputesFiles_filesListContainer__1bl4c","filesButton":"PosDisputesFiles_filesButton__3qK6a"};